import { Card, CardContent, Skeleton } from "@mindstonehq/ui";
import type { ImpactStat } from "~/lib/profile-celebration";

export function ProfileImpactStripSkeleton() {
  return (
    <Card aria-hidden>
      <CardContent className="grid grid-cols-2 gap-3 p-4 sm:grid-cols-4">
        <Skeleton className="h-16" />
        <Skeleton className="h-16" />
        <Skeleton className="h-16" />
        <Skeleton className="h-16" />
      </CardContent>
    </Card>
  );
}

export default function ProfileImpactStrip({
  stats,
}: {
  stats: readonly ImpactStat[];
}) {
  if (stats.length === 0) return null;

  return (
    <Card>
      <CardContent className="grid grid-cols-2 gap-3 p-3 sm:grid-cols-4">
        {stats.map((stat) => (
          <a
            key={stat.key}
            href={stat.href}
            className="rounded-lg border border-border bg-muted/30 px-3 py-3 transition-colors hover:border-primary/20 hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <div className="text-2xl font-semibold leading-none text-foreground">
              {stat.value}
            </div>
            <div className="mt-1 text-sm font-medium text-foreground">
              {stat.label}
            </div>
            {stat.caption && (
              <div className="mt-1 text-xs text-muted-foreground">
                {stat.caption}
              </div>
            )}
          </a>
        ))}
      </CardContent>
    </Card>
  );
}
